import { Layers } from "appworks/graphics/layers/layers";
import { SpineContainer } from "appworks/graphics/pixi/spine-container";
import { gameLayers, LayerNames } from "game-layers";

export function TGRSetupLayers() {

    const layerOrder = {
        default: [
            LayerNames.Jurisdiction,
            LayerNames.Templates,
            LayerNames.Background,
            LayerNames.MatrixBackground,
            LayerNames.MatrixContent,
            LayerNames.Anticipation,
            LayerNames.SymbolAnimations,
            LayerNames.FreespinsIntro,
            LayerNames.MatrixForeground,
            LayerNames.Paylines,
            LayerNames.PaytableButton,
            LayerNames.CelebrationBackground,
            LayerNames.CelebrationContent,
            LayerNames.ReelDust,
            LayerNames.CelebrationForeground,
            LayerNames.InstantWins,
            LayerNames.PaytableCommon,
            LayerNames.PaytableContent,
            LayerNames.JackpotValues,
            LayerNames.Prompts,
            LayerNames.Menus,
            LayerNames.TigerHeader,
            LayerNames.Header,
            LayerNames.MenuContent,
            LayerNames.BetBar,
            LayerNames.Autoplay,
            LayerNames.SmartButton,
            LayerNames.Skip,
            LayerNames.Turbo,
            LayerNames.Footer,
            LayerNames.Prompts,
            LayerNames.Freegames,
            LayerNames.History
        ]
    };

    Layers.setLayerOrderConfig(layerOrder, LayerNames);

    gameLayers.Background.onSceneEnter.addOnce((scene: string) => {
        if (scene === "default") {
            const fsSprite = gameLayers.Background.getSprite("bg_fs");
            fsSprite.visible = false;
            const fsSpine: SpineContainer = gameLayers.Background.getSpine("fs_spine");
            fsSpine.visible = false;

            const bgSprite = gameLayers.Background.getSprite("bg_idle");
            bgSprite.visible = true;
            const bgSpine: SpineContainer = gameLayers.Background.getSpine("bg_spine");
            bgSpine.play("loop");
        }
    });
}
